function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#fc5giaylxa)",
  transform: "translate(-165 -123)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.609 8c0 3.644-2.965 6.609-6.609 6.609S1.391 11.644 1.391 8 4.356 1.391 8 1.391 14.609 4.356 14.609 8M16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8 8-3.589 8-8M9.26 4.53c.16-.161.253-.386.253-.613 0-.23-.092-.454-.254-.616-.162-.162-.386-.254-.616-.254-.227 0-.452.092-.613.254-.164.162-.256.386-.256.616 0 .227.092.452.256.613.161.162.384.256.613.256.23 0 .454-.094.616-.256m-1.728 8.307c-.136 0-.27-.046-.381-.135-.176-.142-.26-.37-.216-.592l.857-4.35-.472.266c-.293.165-.664.062-.829-.231-.165-.293-.061-.664.232-.83l1.623-.914c.207-.116.463-.102.655.038.193.139.287.377.24.61l-.887 4.507.728-.317c.309-.134.667.007.801.315.135.308-.007.666-.315.8l-1.792.782c-.078.034-.161.05-.244.05",
  transform: "translate(165 123)"
}))));

function SvgIconInfocolorless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfocolorless);
export default __webpack_public_path__ + "static/media/icon-infocolorless.f0973c19.svg";
export { ForwardRef as ReactComponent };